import { render, staticRenderFns } from "./InputSettings.vue?vue&type=template&id=3bdf02c7"
import script from "./InputSettings.vue?vue&type=script&lang=js"
export * from "./InputSettings.vue?vue&type=script&lang=js"
import style0 from "./InputSettings.vue?vue&type=style&index=0&id=3bdf02c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports